export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS";
export const GET_USER = "GET_USER";
export const SORT_BY_VALUE = "SORT_BY_VALUE";
export const GET_NAME_PRODUCT = "GET_NAME_PRODUCT";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const SET_NAME_SEARCH = "SET_NAME_SEARCH";
export const LOADING_PRODUCTS = "LOADING_PRODUCTS";
export const ADD_QUESTION = "ADD_QUESTION";
export const GET_QUESTIONS_WITH_ANSWERS = "GET_QUESTIONS_WITH_ANSWERS";
export const LOADING_USER = "LOADING_USER";
export const UPDATE_GOOGLE_AUTH_ERROR_MESSAGE =
  "UPDATE_GOOGLE_AUTH_ERROR_MESSAGE";
export const LOGIN_ERROR_MESSAGE = "LOGIN_ERROR_MESSAGE";
export const SET_REGISTER_ERROR_MESSAGE = "SET_REGISTER_ERROR_MESSAGE";
export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_ERROR = "CREATE_PRODUCT_ERROR";
export const ADD_TO_CART = "ADD_TO_CART";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
export const ADD_ORDER = "ADD_ORDER";
export const UPDATE_CART_SUCCESS_MESSAGE = "UPDATE_CART_SUCCESS_MESSAGE";
export const UPDATE_CART_ERROR_MESSAGE = "UPDATE_CART_ERROR_MESSAGE";
export const GET_USER_PUBLICATIONS = "GET_USER_PUBLICATIONS";
export const SET_PRODUCT_TO_EDIT = "SET_PRODUCT_TO_EDIT";
export const SET_EDIT_INITIAL_VALUES = "SET_EDIT_INITIAL_VALUES";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR";
export const RESTORE_PASSWORD_SUCCESS_MESSAGE =
  "RESTORE_PASSWORD_SUCCESS_MESSAGE";
export const RESTORE_PASSWORD_ERROR_MESSAGE = "RESTORE_PASSWORD_ERROR_MESSAGE";
export const MERCADO_PAGO = "MERCADO_PAGO";
export const MY_PURCHASES = "MY_PURCHASES";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_NOTIFICATIONS_BY_PRODUCT =
  "UPDATE_NOTIFICATIONS_BY_PRODUCT";
export const ADD_ANSWER = "ADD_ANSWER";
export const SET_REGISTER_SUCCESS_MESSAGE = "SET_REGISTER_SUCCESS_MESSAGE";
export const FETCH_ADD_REVIEW = "FETCH_ADD_REVIEW";
export const ADD_REVIEW_SUCCESS = "ADD_REVIEW_SUCCESS";
export const ADD_REVIEW_ERROR = "ADD_REVIEW_ERROR";
export const GET_PRODUCT_REVIEWS = "GET_PRODUCT_REVIEWS";
export const GET_MY_SALES = "GET_MY_SALES";
export const SET_SALE_TO_EDIT = "SET_SALE_TO_EDIT";
export const SET_SALE_INITIAL_VALUE = "SET_SALE_INITIAL_VALUE";
export const UPDATE_SALE_REQUEST = "UPDATE_SALE_REQUEST";
export const UPDATE_SALE_SUCCESS = "UPDATE_SALE_SUCCESS";
export const UPDATE_SALE_ERROR = "UPDATE_SALE_ERROR";
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_SALES_PAYABLE = "GET_SALES_PAYABLE";

